<template>
  <b-button variant="outline-danger" v-on:click="pressed">{{$t("REMOVE")}}</b-button>
</template>
<script>
import { ajaxDelete } from "../../ajax";
import {apiUrl} from "@/main";

export default {
  props: ["ClassID", "StudentID", "token"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      ajaxDelete(
        apiUrl()+ "/classes/" +
          this.ClassID +
          "/students/" +
          this.StudentID,
        this.deleteSuccess,
        this.dataError,
        this.token
      );
    },
    deleteSuccess: function() {
      this.$emit('removeStudent', this.StudentID);
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    }
  }
};
</script>